import "./Header.scss";
import Button from "./Button";
import Logo from "../../assets/images/logo.png";
import { useState } from "react";
import { ReactComponent as Menu } from "../../assets/icons/menu.svg";
import { Add } from "iconsax-react";
import { NavLink } from "react-router-dom";

export default function Header() {
	const [isHovered, setIsHovered] = useState(false);

	/* sidebar active */
	const [sidebarActive, setSidebarActive] = useState(false);

	const toggleSidebar = () => {
		setSidebarActive(!sidebarActive);
	};

	const closeSidebar = () => {
		setSidebarActive(false);
	};

	const handleScroll = (e) => {
		e.preventDefault(); // Prevent default anchor behavior
		closeSidebar();
		const target = e.target.getAttribute("href").substring(1);
		const targetElement = document.querySelector(target);
		const headerHeight = document.querySelector(".header").offsetHeight;

		const yOffset = -headerHeight; // Negative offset to account for the header
		const yPosition =
			targetElement.getBoundingClientRect().top +
			window.pageYOffset +
			yOffset;

		window.scrollTo({ top: yPosition, behavior: "smooth" });
	};

	return (
		<div className="header">
			<div className="decoration header-light-1"></div>

			<div className="header-content content-wrapper-lg">
				<div className="header-left">
					{!sidebarActive && (
						<button
							className="sidebar-toggle"
							onClick={toggleSidebar}
						>
							<Menu />
						</button>
					)}
				</div>

				<div className="header-center">
					<img className="header-logo" src={Logo} alt="logo" />
				</div>

				<div className="header-right">
					<Button
						className="launch-dapp-btn"
						onMouseEnter={() => setIsHovered(true)}
						onMouseLeave={() => setIsHovered(false)}
					>
						{isHovered ? "COMING SOON" : "DApp"}
					</Button>
				</div>
			</div>

			{/* <div
				className={`sidebar-backdrop ${sidebarActive ? "active" : ""}`}
				onClick={closeSidebar}
			></div> */}
			<div className={`sidebar ${sidebarActive ? "active" : ""}`}>
				<div className="sidebar-content">
					<div className="sidebar-header">
						<button
							className="sidebar-close"
							onClick={closeSidebar}
						>
							<Add
								size="40"
								color="#808080"
								className="add-icon"
							/>
						</button>
					</div>

					<div className="sidebar-body">
						<ul className="sidebar-nav">
							<li>
								<a href="/#about-us" onClick={handleScroll}>
									About Us
								</a>
							</li>
							<li>
								<a href="/#our-products" onClick={handleScroll}>
									Our Products
								</a>
							</li>
							<li>
								<a href="/#roadmap" onClick={handleScroll}>
									Roadmap
								</a>
							</li>
							<li>
								<a href="/#tokenomics" onClick={handleScroll}>
									AUR Token
								</a>
							</li>
							<li>
								<a href="/#contact-us" onClick={handleScroll}>
									Get In Touch
								</a>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</div>
	);
}
